export const RESIZE_LINE_SIZE = 4;

export const MIN_ROW_HEIGHT = 60;
export const MAX_ROW_HEIGHT = 1500;
export const WIDGET_HEADER_HEIGHT = 32;
export const MIN_COLUMN_WIDTH = 128;
export const MAX_COLUMN_WIDTH = 2048;

export const Z_INDEX_RESIZE_OVERLAY = 100;
export const Z_INDEX_RESIZE_LINE = 101;
export const Z_INDEX_CELL_DROPZONE = 102;
export const Z_INDEX_ROW_DROPZONE = 103;
export const Z_INDEX_ACTIVE_DRAGGABLE = 104;
